'use client';

import { Chip } from '@coolblue-development/freddy';
import navigateTrigger from '@coolblue-development/ga4-events/triggers/SegmentNavigation/navigateTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';

export function MobileSegmentNavigationItem({
  href,
  urlIndexable,
  title,
  event
}: {
  href: string;
  urlIndexable: boolean;
  title: string;
  event: ReturnType<typeof navigateTrigger>;
}) {
  const { trackEvent } = useAnalytics();
  const nofollow = (urlIndexable: boolean) => (!urlIndexable ? 'nofollow' : undefined);

  return (
    <Chip href={href} rel={nofollow(urlIndexable)} onClick={() => trackEvent(event)}>
      {title}
    </Chip>
  );
}
